import React from 'react';
import {
  Modal, Fade, Box, Backdrop,
} from '@mui/material';

import './styles.scss';

interface Props {
  children: React.ReactElement<any, string | React.JSXElementConstructor<any>>;
  open: boolean;
  onClose: () => void;
  modalClass?: string;
  container?: Element | (() => Element | null) | null | undefined;
}

const CustomModal = ({
  children, open, onClose, modalClass, container,
} : Props) => {
  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
  };
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      disableEscapeKeyDown
      container={container}
    >
      <Fade in={open}>
        <Box sx={style} className={`custom-modal-body ${modalClass}`}>
          {children}
        </Box>
      </Fade>
    </Modal>
  );
};

CustomModal.defaultProps = {
  modalClass: '',
  container: undefined,
};

export default CustomModal;
